<template>
    <div>
        <configurator v-if="!loading" :start-step="1"></configurator>
    </div>
</template>

<script>
    import Configurator from "@/components/Configurator";
    import orderinitmixins from "./orderinitmixins"

    export default {
        name: "Create",
        components: {Configurator},
        mixins: [orderinitmixins],
    }
</script>

<style scoped>

</style>
